import React from 'react';
import { SlBadge } from "react-icons/sl";
import QProcess from './QProcess';

const FeatureGrid = () => {
  const containerStyle = {
    width: '100%',
    maxWidth: '1400px',
    margin: '0 auto',
    padding: '40px',
    backgroundColor: 'white',
    borderRadius: '12px',
    // boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
    
  };

  const qualityPolicyContainer = {
    textAlign: 'center',
    padding: '10px',
    // marginBottom: '40px',
    // backgroundColor: '#f8f9fa',
    borderRadius: '8px',
    // boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
  };

  const policyHeader1 = {
    fontSize: '28px',
    fontWeight: 'bold',
    color: '#ff9200',
    marginTop:"60px",
    marginBottom: '25px',
  };

  const policyHeader= {
    fontSize: '28px',
    fontWeight: 'bold',
    color: '#ff9200',
    marginTop:"20px",
    marginBottom: '25px',
    marginLeft: '-20px',
  };

  // const qualityProcessSection = {
  //   display: 'flex',
  //   alignItems: 'center',
  //   justifyContent: 'center',
  //   gap: '40px',
  //   flexWrap: 'wrap',
  // };
  
  // const circleWrapper = {
  //   width: '160px',
  //   height: '160px',
  //   borderRadius: '50%',
  //   backgroundColor: '#e6f0fa',
  //   display: 'flex',
  //   alignItems: 'center',
  //   justifyContent: 'center',
  //   boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
  // };
  
  
  // const badgeImage = {
  //   width: '80px',
  //   height: '80px',
  // };
  
  // const qualityProcessWrapper = {
  //   display: 'flex',
  //   flexDirection: 'column',
  //   gap: '12px',
  // };
  
  // const qualityStep = {
  //   backgroundColor: '#003366',
  //   color: 'white',
  //   padding: '10px 25px',
  //   borderRadius: '50px',
  //   fontSize: '15px',
  //   fontWeight: '500',
  //   width: 'fit-content',
  //   boxShadow: '0 3px 6px rgba(0, 0, 0, 0.1)',
  // };
  
//   // Staggered marginLeft
//   const step1 = { marginLeft: '0px' };
// const step2 = { marginLeft: '30px' };
// const step3 = { marginLeft: '50px' };
// const step4 = { marginLeft: '60px' };
// const step5 = { marginLeft: '80px' };
// const step6 = { marginLeft: '60px' };
// const step7 = { marginLeft: '50px' };
// const step8 = { marginLeft: '30px' };
// const step9 = { marginLeft: '0px' };

  


  
  const policyText = {
    fontSize: '18px',
    color: '#333',
    lineHeight: '1.6',
    maxWidth: '1000px',
    margin: '0 auto',
    
    textAlign: 'justify',
  };

  const headerStyle = {
    textAlign: 'center',
    marginBottom: '50px',
  };

  const descriptionStyle = {
    color: '#4B5563',
    fontSize: '1.3rem',
    lineHeight: '1.7',
    maxWidth: '1200px',
    margin: '0 auto 30px',
    padding: '0 20px',
  };

  const titleStyle = {
    fontSize: '1.8rem',
    fontWeight: '600',
    color: '#1E3A8A',
    marginBottom: '50px',
    padding: '0 20px',
    lineHeight: '1.4',
  };

  const gridStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: '30px',
    padding: '20px',
  };

  const featureStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    transition: 'transform 0.3s',
  };

  const iconContainerStyle = {
    backgroundColor: '#ff7800',
    width: '120px',
    height: '120px',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '20px',
    boxShadow: '0 6px 15px rgba(243, 173, 43, 0.97)',
    transition: 'transform 0.3s, box-shadow 0.3s',
  };

  const featureTitleStyle = {
    fontSize: '1.55rem',
    fontWeight: '500',
    lineHeight: '1.5',
    color: 'black',
    maxWidth: '280px',
    margin: '0 auto',
  };

  const handleMouseEnter = (e) => {
    const iconContainer = e.currentTarget.querySelector('div');
    e.currentTarget.style.transform = 'translateY(-8px)';
    iconContainer.style.transform = 'scale(1.05)';
    iconContainer.style.boxShadow = '0 8px 20px rgba(241, 171, 39, 0.93)';
  };

  const handleMouseLeave = (e) => {
    const iconContainer = e.currentTarget.querySelector('div');
    e.currentTarget.style.transform = 'translateY(0)';
    iconContainer.style.transform = 'scale(1)';
    iconContainer.style.boxShadow = '0 6px 15px rgba(241, 171, 39, 0.93)';
  };

  const features = [
    { icon: "🎯", title: "Customer Focus" },
    { icon: "🏆", title: "Leadership" },
    { icon: "🤝", title: "Engagement of People" },
    { icon: "⚙️", title: "Process Approach" },
    { icon: "📈", title: "Improvement" },
    { icon: "🔗", title: "Relationship Management" },
    { icon: "📊", title: "Evidence-Based Decision Making" },
    { icon: "✅", title: "Commitment to Satisfy Applicable Requirements" },
  ];

  return (
    <div style={containerStyle}>
      
      {/* Quality Policy Section */}
      <div style={qualityPolicyContainer}>
        <p style={{ color: '#555', fontSize: '18px',textAlign:'left', textAlign: 'justify' }}>
        We at Sri Engineering (Tool Room) give immense focus on continuous improvement in all our process and our technical capabilities  has put in position to serve with high quality has  put us in position to serve with high quality globally acceptable products.  We ensure that the quality is monitored at each stage of the  injection moulding process. 
        From Raw material procurement, to delivery of finished goods at customer’s end, we ensure there is a quality inspector at each stage and that every piece is thoroughly checked inside out. All the incoming material, in house processes and the final packaging of the components is validated and checked at each interval. We ensure that we have 0 PPM at our customer’s end. 
        Sri Engineering (Tool Room)  also  follows the in-house quality control practices like 4M, 5S, Kaizen to achieve such standards,  Sri Engineering (Tool Room) has  invested in state of the art testing machines (Melt flow Index) and measuring resource of instruments for Precision Parts Molding from 1gm to 400 gm 

          
        </p>
        <h2 style={policyHeader1}>Quality Policy</h2>
        <p style={{textAlign:'left',fontSize: '18px',textAlign: 'justify' }}>
          We, at M/s Sri Engineering(Tool Room), are committed to the manufacture of Plastic Injection Moulds, Components, Jigs, and Fixtures. 
          We ensure timely delivery of services to enhance customer satisfaction through efficient resource utilization, 
          striving for continuous improvement in processes and products.
        </p>
       
      </div>
       

      {/* Existing Feature Section */}
      {/* <div style={headerStyle}>
       
        <h2 style={titleStyle}>
          Special focus areas that have made Sri Engineering(Tool Room) an industry leader:
        </h2>
      </div> */}

      <div style={gridStyle}>
        {features.map((feature, index) => (
          <div 
            key={index} 
            style={featureStyle}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <div style={iconContainerStyle}>
              <span style={{ fontSize: '42px', color: 'white' }}>{feature.icon}</span>
            </div>
            <p style={featureTitleStyle}>{feature.title}</p>
          </div>
        ))}
      </div>
      <div style={headerStyle}>
       
       <h2 style={titleStyle}>
         {/* Special focus areas that have made Sri Engineering(Tool Room) an industry leader: */}
       </h2>
     </div>
      {/* Process Details */}
      {/* <div style={qualityPolicyContainer}>
        <h2 style={policyHeader}>Process Approach</h2>
        <p style={policyText}>✔ Control Plan & quality standards available for every part.</p>
        <p style={policyText}>✔ PPAP submitted for every new part.</p>
        <p style={policyText}>✔ 8D approach to problem-solving.</p>
        <p style={policyText}>✔ Adequate storage - Raw material – FIFO system, Stock Board system with Min & Max.</p>
        <p style={policyText}>✔ Adequate Rack storage – Customer property - Mold-Tool History card.</p>
        <p style={policyText}>✔ 5’S system implementation.</p>
      </div> */}

<div style={containerStyle}>
  {/* <div style={qualityPolicyContainer}>
    
    <div style={qualityProcessSection}>
     
      <h2 style={policyHeader}>Quality <br/> Process  </h2>

      <div style={circleWrapper}>
  <SlBadge size={60} color="#003366" />
</div>

   
      <div style={qualityProcessWrapper}>
        <div style={{ ...qualityStep, ...step1 }}>Production Plan Approval Process</div>
        <div style={{ ...qualityStep, ...step2 }}>PPAP New Parts</div>
        <div style={{ ...qualityStep, ...step3 }}>Control Plan</div>
        <div style={{ ...qualityStep, ...step4 }}>Failure Mode Effect Analysis</div>
        <div style={{ ...qualityStep, ...step5 }}>Poke Yoke</div>
        <div style={{ ...qualityStep, ...step6 }}>Statistical Process Control</div>
        <div style={{ ...qualityStep, ...step7 }}>8D Approach Problem Solving</div>
        <div style={{ ...qualityStep, ...step8 }}>Final Inspection</div>
        <div style={{ ...qualityStep, ...step9 }}>Total Quality Maintenance</div>
      </div>
    </div>
  </div> */}
  <QProcess/>
</div>


        {/* ISO Certifications */}
        <div style={qualityPolicyContainer}>
        <h2 style={policyHeader}>Certifications & Achievements</h2>
        <p style={policyText}>✔ ISO 9001:2015 Quality Management System certified by URS</p>
        <p style={policyText}>✔ Certified for SQ Mark Audit by Hyundai Motor</p>
        <p style={policyText}>✔ MACE certified Company by Maruti</p>
        <p style={policyText}>✔ Best Performance Of The Year 2024-25 Vendor - Kwangjin</p>
      </div>
    </div>
  );
};

export default FeatureGrid;
